import * as React from 'react';
import { useSelector } from 'react-redux';
import { CallbackWidget } from '@cian/callback-widget';
import { getFilters, getPhone, getUser, getUserPhone } from '../../selectors';
import { getTimezoneByRegionId } from '../../utils';
import { ApplicationContext } from '../../utils/applicationContext';
import { getPrivacyPolicyUrl, getSmsDisclaimerState } from './helpers';
import { DEVELOPER_REALTY_USER_ID } from '../../constants';
import { getWorkTimeSchedule } from '../../services/workTime';
import { ECallbackPlace, ICallbackParams } from '../../types/callback';
import { trackSendCallbackRequest } from '../../services/callback';
import { requestCallback } from '../../services/callbackRequest';

interface ICallbackPopupProps {
  onClose(): void;
  open: boolean;
  place: ECallbackPlace;
}

export function CallbackPopup({ onClose, open, place }: ICallbackPopupProps) {
  const context = React.useContext(ApplicationContext);
  const { location } = useSelector(getFilters);
  const userPhone = useSelector(getUserPhone);
  const user = useSelector(getUser);
  const agentPhone = useSelector(getPhone);

  const timezone = getTimezoneByRegionId(location);
  const privacyPolicyUrl = getPrivacyPolicyUrl(context.config);
  const isSMSDisclaimerEnabled = getSmsDisclaimerState(context.config);

  const handleRequestCallback = React.useCallback(
    async (parameters: ICallbackParams) => {
      const result = await requestCallback(context, parameters);
      trackSendCallbackRequest(place, parameters, user);

      return result;
    },
    [context, place, user],
  );

  const handleRequestWorkTime = React.useCallback(async () => {
    return getWorkTimeSchedule(context, { userId: DEVELOPER_REALTY_USER_ID });
  }, [context]);

  return (
    <CallbackWidget
      agentPhone={agentPhone}
      onClose={onClose}
      onRequestCallback={handleRequestCallback}
      onRequestWorkTime={handleRequestWorkTime}
      open={open}
      privacyPolicyUrl={privacyPolicyUrl}
      timezoneOffset={timezone}
      theme="pik"
      userPhoneNumber={userPhone}
      isSMSDisclaimerEnabled={isSMSDisclaimerEnabled}
    />
  );
}
